import { useEffect, useRef } from 'react';

const ReplayPathMapGoogle = ({ map, googleMapsApi, positions, subPositions }) => {
    const mainPolylineRef = useRef(null);
    const subPolylineRef = useRef(null);

    useEffect(() => {
        if (!map || !googleMapsApi || !positions || positions.length === 0) {
            if (mainPolylineRef.current){
                mainPolylineRef.current.setMap(null);
                mainPolylineRef.current = null;
            }
            return;
        }

        const pathCoordinates = positions.map(pos => ({
            lat: pos.latitude,
            lng: pos.longitude,
        }));

        if (mainPolylineRef.current) {
            mainPolylineRef.current.setPath(pathCoordinates);
        }
        else {
            const polyline = new googleMapsApi.Polyline({
                path: pathCoordinates,
                geodesic: true,
                strokeColor: '#C5C8F7',
                strokeOpacity: 1.0,
                strokeWeight: 5,
                map: map,
            });
            mainPolylineRef.current = polyline;
        }

        const bounds = new googleMapsApi.LatLngBounds();
        pathCoordinates.forEach(coord => bounds.extend(coord));
        if (map.getDiv().offsetWidth > 0 && map.getDiv().offsetHeight > 0) {
            map.fitBounds(bounds, { top: 5, bottom: 295, left: 25, right: 25 });
        }

        return () => {
            if (mainPolylineRef.current){
                mainPolylineRef.current.setMap(null);
                mainPolylineRef.current = null;
            }
            if (subPolylineRef.current) {
                subPolylineRef.current.setMap(null);
                subPolylineRef.current = null;
            }
        };
    }, [map, googleMapsApi, positions]);

    useEffect(() => {
        if (!map || !googleMapsApi || !subPositions || subPositions.length === 0) {
            if (subPolylineRef.current){
                subPolylineRef.current.setMap(null);
                subPolylineRef.current = null;
            }
            return;
        }

        const pathCoordinates = subPositions.map(pos => ({
            lat: pos.latitude,
            lng: pos.longitude,
        }));

        if (subPolylineRef.current) {
            subPolylineRef.current.setPath(pathCoordinates);
            if (subPolylineRef.current.getMap() !== map)
                subPolylineRef.current.setMap(map);
        }
        else {
            const polyline = new googleMapsApi.Polyline({
                path: pathCoordinates,
                geodesic: true,
                strokeColor: '#0000FF',
                strokeOpacity: 1.0,
                strokeWeight: 5,
                map: map,
            });
            subPolylineRef.current = polyline;
        }

        return () => {
            if (subPolylineRef.current){
                subPolylineRef.current.setMap(null);
            }
        };
    }, [map, googleMapsApi, subPositions]);

    return null;
};

export default ReplayPathMapGoogle;